import { ImportCsvRoomResultEntity, ImportCsvRoomResultResponse } from 'src/types'

export const RoomCsvTranslator = {
  toEntities: (response: ImportCsvRoomResultResponse): ImportCsvRoomResultEntity[] => {
    return response.rooms.map((room, index) => ({
      rowNumber: index + 1,
      wingName: room.wingName,
      floor: room.floor,
      roomName: room.roomName,
      roomTypeName: room.roomTypeName,
      selectDisabled: room.selectDisabled,
      result:
        room.result === 'SUCCESS' ? 'success' : room.result === 'CONFLICT' ? 'conflict' : 'error',
      message: room.message,
    }))
  },
} as const
